export var AlignmentEnum;
(function (AlignmentEnum) {
    AlignmentEnum["LEFT"] = "left";
    AlignmentEnum["CENTER"] = "center";
    AlignmentEnum["RIGHT"] = "right";
})(AlignmentEnum || (AlignmentEnum = {}));
